import $ from 'jquery';

export const importation = () => {
  // Enabling file selector
  const $importButton = $('button[form="import-users"]');
  const $form = $('form#import-users');

  // Handling file input
  $form.find('input:text, .ui.button', '.ui.action.input').on('click', e => {
    $('input:file', $(e.target).parents()).click();
  });

  $form.find('input:file', '.ui.action.input').on('change', e => {
    $importButton.removeClass('disabled');
    var name = e.target.files[0].name;
    $('input:text', $(e.target).parent()).val(name);
  });

  $importButton.on('click', evt => {
    $importButton.addClass('loading');
    $form.submit();
  });
};



// WEBPACK FOOTER //
// ./src/modules/user/index.js